import { KrCard } from '@/common/card/KrCard';
import { Spacer, SpacerLayout } from '@/common/layout/SpacerLayout';
import { useState } from 'react';
import { FinanceDashboardCardChart } from '../cards/FinanceDashboardCardChart';
import { FinanceDashboardNetChart } from '../charts/FinanceDashboardNetChart';
import { FinanceDashboardPlChart } from '../charts/FinanceDashboardPlChart';
import { FinanceDashboardSankeyChart } from '../charts/FinanceDashboardSankeyChart';
import { FinanceDashboardWaterfallChart } from '../charts/FinanceDashboardWaterfallChart';

export const DemFinanceDashboardPlView = ({ startPeriod, endPeriod, periodicity, prodIds, channelIds, periods }) => {
  const [hoverCategory, setHoverCategory] = useState(null);

  return (
    <SpacerLayout>
      <Spacer>
        <Spacer weights={[5, 1]} vertical>
          <KrCard title="Gross-To-Net">
            <FinanceDashboardPlChart
              entity="SBC"
              chartType="STACK"
              startPeriod={startPeriod}
              endPeriod={endPeriod}
              periodicity={periodicity}
              prodIds={prodIds}
              channelIds={channelIds}
              onHoverCategoryChange={setHoverCategory}
              periods={periods}
            />
          </KrCard>
          <Spacer>
            <FinanceDashboardCardChart
              entity="SBC"
              direction="Increase"
              changeType="percent"
              startPeriod={startPeriod}
              endPeriod={endPeriod}
              periodicity={periodicity}
              prodIds={prodIds}
              channelIds={channelIds}
            />
            <FinanceDashboardCardChart
              entity="SBC"
              direction="Decrease"
              changeType="percent"
              startPeriod={startPeriod}
              endPeriod={endPeriod}
              periodicity={periodicity}
              prodIds={prodIds}
              channelIds={channelIds}
            />
          </Spacer>
        </Spacer>
        {hoverCategory ?
          <Spacer vertical>
            <KrCard title={`Sankey ${hoverCategory}`}>
              <FinanceDashboardSankeyChart
                entity="SBC"
                startPeriod={startPeriod}
                endPeriod={endPeriod}
                periodicity={periodicity}
                prodIds={prodIds}
                channelIds={channelIds}
                hoveredCategory={hoverCategory}
              />
            </KrCard>

            <KrCard title={`Waterfall ${hoverCategory}`}>
              <FinanceDashboardWaterfallChart
                entity="SBC"
                startPeriod={startPeriod}
                endPeriod={endPeriod}
                periodicity={periodicity}
                prodIds={prodIds}
                channelIds={channelIds}
                hoveredCategory={hoverCategory}
              />
            </KrCard>
          </Spacer>
        : <KrCard title={`Net Sales YoY % Growth`}>
            <FinanceDashboardNetChart
              entity="SBC"
              startPeriod={startPeriod}
              endPeriod={endPeriod}
              periodicity={periodicity}
              prodIds={prodIds}
              channelIds={channelIds}
            />
          </KrCard>
        }
      </Spacer>
    </SpacerLayout>
  );
};
